"use strict";

import angular from "angular";


function bxDesktop ($q) {

  
    return {
     
      action:  function(action, data){
        data = data || {};
        var deffered= $q.defer();
        let bx = window.BX;

        bx.ajax.runComponentAction('cript:desktop', action, {
            mode:'class',
            data:data
        }).then(function(response){
           
            
            if(response.status!=="success"){
               
                console.error('unable load action '+action);
                deffered.reject(response.errors);
                return;
            }

            deffered.resolve(response.data) 

        },function( response){
            console.error('unable load action'+action, response.errors);
            deffered.reject(response.errors);
        });

        return deffered.promise; 
      }

      
    };
}


function bxProfile ($q) {

  
    return {
     
      action:  function(action, data){
        data = data || {};
        var deffered= $q.defer();
        let bx = window.BX;
        bx.ajax.runComponentAction('cript:profile', action, {
            mode:'class',
            data:data
        }).then(function(response){
           
            
            if(response.status!=="success"){
               
                console.error('unable load action '+action);
                deffered.reject(response.errors);
                return;
            }

            deffered.resolve(response.data) 

        },function( response){
            console.error('unable load action'+action, response.errors);
            deffered.reject(response.errors);
        });

        return deffered.promise; 
      }

      
    };
}


function ymapsLoader ($window, $timeout, $script) {
    "use strict";
    var scriptPromise;
    return {
        ready: function(callback) {
            if(!scriptPromise) {
                scriptPromise = $script("https://api-maps.yandex.ru/2.1/?lang=ru_RU&coordorder=longlat&apikey=c06d1eb0-72a4-46d1-8522-67c21c3a0953").then(function() {
                    return $window.ymaps;
                });
            }
            scriptPromise.then(function(ymaps) {
                ymaps.ready(function() {
                    $timeout(function() {callback(ymaps);});
                });
            });
        }
    };
}


function $script($q, $rootScope) {
    "use strict";
    //классический кроссбраузерный способ подключить внешний скрипт
    function loadScript(path, callback) {
        var el = document.createElement("script");
        el.onload = el.onreadystatechange = function () {
            if (el.readyState && el.readyState !== "complete" &&
                el.readyState !== "loaded") {
                return;
            }
            // если все загрузилось, то снимаем обработчик и выбрасываем callback
            el.onload = el.onreadystatechange = null;
            if(angular.isFunction(callback)) {
                callback();
            }
        };
        el.async = true;
        el.src = path;
        document.getElementsByTagName('body')[0].appendChild(el);
    }
    var loadHistory = [], //кэш загруженных файлов
        pendingPromises = {}; //обещания на текущие загруки
    return function(url) {
        var deferred = $q.defer();
        if(loadHistory.indexOf(url) !== -1) {
            deferred.resolve();
        }
        else if(pendingPromises[url]) {
            return pendingPromises[url];
        } else {
            loadScript(url, function() {
                delete pendingPromises[url];
                loadHistory.push(url);
                //обязательно использовать `$apply`, чтобы сообщить
                //angular о том, что что-то произошло
                $rootScope.$apply(function() {
                    deferred.resolve();
                });
            });
            pendingPromises[url] = deferred.promise;
        }
        return deferred.promise;
    };
}


$script.$inject = ['$q', '$rootScope'];
bxDesktop.$inject = ['$q'];
bxProfile.$inject = ['$q'];
ymapsLoader.$inject = ['$window', '$timeout', '$script'];

export { 

    bxDesktop,
    bxProfile,
    ymapsLoader,
    $script

};



// WEBPACK FOOTER //
// ./src/app.factory.js